export const normalizeCustomerUuids = (uuids: string[] = []): string[] =>
  Array.from(new Set(uuids.map((uuid) => String(uuid || "").trim()).filter(Boolean))).sort();

export const serializeCustomerUuids = (uuids: string[]): string =>
  normalizeCustomerUuids(uuids).join("|");

export const hasCustomerCompanyScopeChanges = (
  currentCustomerUuids: string[],
  initialCustomerUuids: string[]
): boolean => serializeCustomerUuids(currentCustomerUuids) !== serializeCustomerUuids(initialCustomerUuids);

export interface ICustomerCompanyScopeSaveState {
  hasSavedUser: boolean;
  hasChanges: boolean;
  isScopeLoading: boolean;
  isScopeFetching: boolean;
  isUpdating: boolean;
}

export const canSaveCustomerCompanyScope = ({
  hasSavedUser,
  hasChanges,
  isScopeLoading,
  isScopeFetching,
  isUpdating,
}: ICustomerCompanyScopeSaveState): boolean =>
  hasSavedUser && hasChanges && !isScopeLoading && !isScopeFetching && !isUpdating;

export const getCustomerCompanyScopeSummaryLabel = (
  totalCustomerCompanies: number | null | undefined
): string => `${Number(totalCustomerCompanies || 0).toLocaleString()} บริษัท`;

export const shouldShowCustomerCompanyScopeSummary = (
  totalCustomerCompanies: number | null | undefined
): boolean => Number(totalCustomerCompanies || 0) > 0;
